require('./stage-padding.scss');

module.exports = {
    removeLeftStagePadding: function ($carousel) {
        $carousel.addClass('stage-padding-right');
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/customization/stage-padding.js
// module id = 44
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17